import { create } from 'zustand';
import type { Me } from '@/types/api';

export type SessionStatus = 'bootstrapping' | 'anonymous' | 'authenticating' | 'authenticated' | 'refreshing' | 'expired';

let accessToken: string | null = null;
export const getAccessToken = () => accessToken;

interface SessionState {
  status: SessionStatus;
  me: Me | null;
  contextSwitching: boolean;
  mobileNavigationOpen: boolean;
  setMe: (me: Me | null) => void;
  setStatus: (status: SessionStatus) => void;
  setAccessToken: (token: string | null) => void;
  applyContextSession: (token: string, context: Me['context'], permissions: string[]) => Me | null;
  establishSession: (token: string) => void;
  clearSession: (status?: Extract<SessionStatus, 'anonymous' | 'expired'>) => void;
  setContextSwitching: (value: boolean) => void;
  setMobileNavigationOpen: (value: boolean) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  status: 'bootstrapping',
  me: null,
  contextSwitching: false,
  mobileNavigationOpen: false,
  setMe: (me) => set({ me }),
  setStatus: (status) => set({ status }),
  setAccessToken: (token) => { accessToken = token; },
  applyContextSession: (token, context, permissions) => {
    accessToken = token;
    let nextMe: Me | null = null;
    set((state) => {
      if (!state.me) return state;
      nextMe = { ...state.me, context, permissions: [...permissions] };
      return { me: nextMe, status: 'authenticated' };
    });
    return nextMe;
  },
  establishSession: (token) => {
    accessToken = token;
    set({ status: 'authenticated' });
  },
  clearSession: (status = 'anonymous') => {
    accessToken = null;
    set({ status, me: null, contextSwitching: false });
  },
  setContextSwitching: (contextSwitching) => set({ contextSwitching }),
  setMobileNavigationOpen: (mobileNavigationOpen) => set({ mobileNavigationOpen }),
}));
